// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const directiveRoutes = [
  {
    path: 'animate-on-scroll',
    loadChildren: () =>
      import('./animate-on-scroll/animate-on-scroll-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'auto-grow',
    loadChildren: () =>
      import('./auto-grow/auto-grow-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'control-value-accessor',
    loadChildren: () =>
      import(
        './control-value-accessor/control-value-accessor-stories.routing'
      ).then(m => m.storyRoutes),
  },
  {
    path: 'hide',
    loadChildren: () =>
      import('./hide/hide-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'long-press',
    loadChildren: () =>
      import('./long-press/long-press-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
  {
    path: 'repeat',
    loadChildren: () =>
      import('./repeat/repeat-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'tagging',
    loadChildren: () =>
      import('./tagging/tagging-stories.routing').then(m => m.storyRoutes),
  },
  {
    path: 'visibility',
    loadChildren: () =>
      import('./visibility/visibility-stories.routing').then(
        m => m.storyRoutes,
      ),
  },
];
